import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './Profile.css'; // Ensure the CSS file is correctly linked
import Settings from './Settings';

function Profile() {
    const { userId } = useParams();
    const loggedInUserId = localStorage.getItem('userId');
    const [playerStats, setPlayerStats] = useState({
        wins: 0,
        goals: 0,
        assists: 0,
        saves: 0,
    });
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [username, setUsername] = useState('');
    const [profilePhoto, setProfilePhoto] = useState('/default-profile.png'); // Default profile photo path
    const [showSettings, setShowSettings] = useState(false);

    useEffect(() => {
        const fetchPlayerStats = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`http://localhost:3001/api/player-stats?userId=${userId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setPlayerStats(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching player stats:', error);
                setLoading(false);
            }
        };

        const fetchUserTeams = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`http://localhost:3001/api/users/${userId}/teams`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setTeams(response.data);
            } catch (error) {
                console.error('Error fetching teams:', error);
            }
        };

        const fetchUsername = async () => {
            try {
                const response = await axios.get(`http://localhost:3001/api/user/${userId}`);
                setUsername(response.data.username);
                setProfilePhoto(response.data.profilePhoto || '/default-profile.png'); // Use default if no profile photo
            } catch (error) {
                console.error('Error fetching username:', error);
            }
        };

        fetchUsername();
        fetchPlayerStats();
        fetchUserTeams();
    }, [userId]);

    const handleSettingsClick = () => {
        setShowSettings(true);
    };

    const handleCloseSettings = () => {
        setShowSettings(false);
    };

    const updateProfile = (updatedProfile) => {
        setUsername(updatedProfile.username);
        setProfilePhoto(updatedProfile.profilePhoto || profilePhoto);
        setTeams(updatedProfile.teams.split(','));
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    const isCurrentUser = userId === loggedInUserId;

    return (
        <div className="profile-container">
            {showSettings && (
                <Settings userId={userId} onClose={handleCloseSettings} updateProfile={updateProfile} />
            )}
            <div className="profile-header">
                <img src={profilePhoto} alt="Profile" className="profile-photo" />
                <h1>{username}'s Player Overview</h1>
                {isCurrentUser && (
                    <button className="settings-button" onClick={handleSettingsClick}>⚙️</button>
                )}
            </div>
            <h2>My Rocket League Stats</h2>
            <div className="stats">
                <p>Username: {username}</p>
                <p>Wins: {playerStats.wins}</p>
                <p>Goals: {playerStats.goals}</p>
                <p>Assists: {playerStats.assists}</p>
                <p>Saves: {playerStats.saves}</p>
            </div>

            <h2>My Teams</h2>
            <div className="teams">
                <ul>
                    {teams.map((team) => (
                        <li key={team._id}>{team.name}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Profile;
